module.exports = __webpack_public_path__ + "static/img/12.f6a592d.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/4/1/1/sp/12.png
// module id = Pa2r
// module chunks = 0